import script from "./SortOptionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortOptionList.vue?vue&type=script&setup=true&lang=ts"

import "./SortOptionList.vue?vue&type=style&index=0&id=63a9ab84&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a9ab84"]])

export default __exports__